import React, { useState, useEffect } from 'react';

const ListWidgetSettings = ({ config, onChange }) => {
  const [title, setTitle] = useState(config.title || '');
  const [dataSource, setDataSource] = useState(config.globalSettings?.dataSource || 'areas');

  useEffect(() => {
    setTitle(config.title || '');
    setDataSource(config.globalSettings?.dataSource || 'areas');
  }, [config]);

  const handleTitleChange = (e) => {
    const newTitle = e.target.value;
    setTitle(newTitle);

    if (onChange) {
      onChange({
        ...config,
        title: newTitle,
      });
    }
  };

  const handleDataSourceChange = (e) => {
    const newDataSource = e.target.value;
    setDataSource(newDataSource);

    if (onChange) {
      onChange({
        ...config,
        globalSettings: {
          ...config.globalSettings,
          dataSource: newDataSource
        }
      });
    }
  };

  return (
    <div className="list-widget-settings">
      <h3>List Widget Einstellungen</h3>
      <div className="form-group">
        <label htmlFor="widget-title">Widget Titel:</label>
        <input
          id="widget-title"
          type="text"
          className="form-control"
          value={title}
          onChange={handleTitleChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="widget-data-source">Datenquelle:</label>
        <select
          id="widget-data-source"
          className="form-control"
          value={dataSource}
          onChange={handleDataSourceChange}
        >
          <option value="areas">Bereiche</option>
          <option value="examinations">Vorsorgen</option>
        </select>
      </div>
    </div>
  );
};

export default ListWidgetSettings;
